var OrganizationProfile;

import Schema from './schema.js';

export default OrganizationProfile = {Schema};
